<template>
    <div id="app">
        <main-header></main-header>
        <main>
            <a-row class="content">
                <a-col :md="14" :sm="0" :xs="0">
                    <h2>欢迎来到H5魔塔游戏世界</h2>
                    <img src="/assets/login.png">
                </a-col>
                <a-col :md="{ span: 8, offset: 0 }" :sm="{ span: 16, offset: 4 }" :xs="{ span: 24, offset: 0}">
                    <a-card>
                        <a-form-model :model="form" :rules="rules" ref="registerForm">
                            <a-form-model-item class="formitem">
                                <a-input v-model="form.qq" placeholder="请输入您的qq号">
                                    <a-icon slot="addonBefore" type="qq" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem">
                                <a-input v-model="form.username" placeholder="请输入用户名（不超过20字）">
                                    <a-icon slot="addonBefore" type="user" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem">
                                <a-input v-model="form.password" type="password" placeholder="请输入密码">
                                    <a-icon slot="addonBefore" type="unlock" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem">
                                <a-input v-model="form.confirmPassword" type="password" placeholder="请再次输入密码">
                                    <a-icon slot="addonBefore" type="unlock" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model>
                        <div>
                            <a-button type="primary" @click="register" :loading="isRegistering" class="register-button">注册</a-button>
                        </div>
                        <div class="carditem">
                            已有账号? <a class="el-link" href="/user/login.html">去登录</a>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </main>
        <div class="bar"></div>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import axios from 'axios'
import { createFormData } from '../../utils/utils'

export default {
    data: () => ({
        form: {
            qq: "",
            username: "",
            password: "",
            confirmPassword: "",
        },
        isRegistering: false,
        rules: {
            qq: [
                { validator: (rule, value, callback) => {
                    if (!/^\d{6,12}$/.test(value)) {
                        callback(new Error("请输入有效的qq号"));
                    } else {
                        callback();
                    }
                }, trigger: 'change' },
                { required: true, message: '请输入qq号' }
            ],
            username: [
                { validator: (rule, value, callback) => {
                    if (value.length > 20) {
                        callback(new Error("用户名最长为20个字符"));
                    } else {
                        callback();
                    }
                }, trigger: 'change' },
                { required: true, message: '请输入用户名' }
            ],
            password: [
                { required: true, message: '请输入密码' }
            ],
            confirmPassword: [
                { validator: (rule, value, callback) => {
                    if (value !== this.ruleForm.pass) {
                        callback(new Error("两次输入的密码不同"));
                    } else {
                        callback();
                    }
                }, trigger: 'change' },
                { required: true, message: '请再次输入密码' },
            ],
        }
    }),
    methods: {
        register() {
            this.$refs.registerForm.validate(async(valid) => {
                if (valid) {
                    this.isRegistering = true;
                    const { qq, username, password } = this.form;
                    try {
                        const { data } = await axios.post("/backend/user/register.php", createFormData({
                            qq, username, password
                        }));
                        if (data.code == 0) {
                            this.$message.success("注册成功");
                            window.location.assign("/");
                        } else {
                            this.$message.error("注册失败，qq号或用户名已经被注册");
                        }
                    } catch (e) {
                        this.$message.error(`注册失败: ${ e }`);
                    } finally {
                        this.isRegistering = false;
                    }
                }
            })
        }
    },
    components: {
        MainHeader, Footer,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
    main {
        background-color: #2C8CF0;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
}
.content {
    margin-top: auto;
    h2 {
        color: white;
    }
    .ant-form-item {
        margin-bottom: 10px;
    }
    .ant-input-group-addon {
        background-color: #2C8CF0;
        color: white;
    }
    .register-button span {
        margin: 0px 40px;
    }
    .ant-form.ant-form-horizontal {
        margin-top: 10px;
    }
    .carditem {
        margin-top: 15px;
    }
}
.bar {
    background-color: #EFF2F9;
    height: 100px;
}
</style>
